"use strict";
/**
 * Created by huangling on 13/12/2018.
 */
const disableMap = {
    kf5: false,
    help: false,
    updateNote: false,
    trialNode: false,
    copyRights: false,
    contactUs: false,
};
const needChange = config => {
    if (config) {
        Object.assign(disableMap, config);
    }
    else if (location.host === 'dmhub.jdcloud-elite.com' || location.search == '?desense=1') {
        disableMap.kf5 = true;
        disableMap.copyRights = true;
        disableMap.trialNode = true;
    }
    else if (location.host === 'dm.jdcloud-elite.com' || location.search == '?desense=2') {
        disableMap.kf5 = true;
        disableMap.copyRights = true;
        disableMap.trialNode = true;
        disableMap.help = true;
        disableMap.updateNote = true;
        disableMap.contactUs = true;
        disableMap.extraStyle = `
            .logo {
                width: 80% !important;
            }
        `;
    }
    else if (location.href.indexOf('/extension/') > -1) {
        disableMap.kf5 = true;
    }
};
needChange();
if (!disableMap.kf5) {
    $(document).ready(function () {
        const zcBtn = document.createElement('div');
        zcBtn.setAttribute('class', 'zcBtn');
        zcBtn.setAttribute('title', '联系客服');
        document.body.appendChild(zcBtn);
    });
}
const hideClasses = [];
if (disableMap.copyRights) {
    hideClasses.push('.copy-right');
}
if (disableMap.contactUs) {
    hideClasses.push('.contact-us');
}
if (disableMap.updateNote) {
    hideClasses.push('.top_productupgrade');
    hideClasses.push('.productupgrade-modal');
    disableMap.extraStyle += `
            .index .index_top .top_wechatfans {
                margin-right: 0px;
            }
        `;
}
if (disableMap.trialNode) {
    hideClasses.push('.purchase');
}
if (disableMap.help) {
    hideClasses.push('.cl-help');
}
if (hideClasses) {
    $(document).ready(function () {
        const style = document.createElement('style');
        style.innerHTML = `
                ${hideClasses.join(',')} {
                    display: none !important;
                }

                ${disableMap.extraStyle}
            `;
        document.body.appendChild(style);
    });
}
//# sourceMappingURL=desensitize.js.map